import { getApolloClientUtils } from '@bfa/nextjs-common/utils';

import createApolloClient from '../apolloClient';

const { initApolloClient, initOnContext, withApolloContext } =
  getApolloClientUtils(createApolloClient);

export { initApolloClient, initOnContext, withApolloContext };
